import Http, { ApiRootType } from '../Http/Http'
import {
    CatalogDisplayNameResponseDTO,
    CatalogLogoResponseDTO,
    CatalogResponseDTO,
    ChannelSettingsDTO,
    CompanyChildDTO,
    CompanyDTO,
    CompanyIdDTO,
    createUserRequestDTO,
    ResetPwdDTO,
    RoleDTO,
    SiteResponseDTO,
    UserDTO,
    UserResponseDTO
} from './ManagementModel'

const http = new Http()
export class ManagementService {
    async getCompanies(): Promise<CompanyDTO[]> {
        try {
            const response = await http.sendGet<CompanyDTO[]>('client/companies', undefined, ApiRootType.one)
            return response.data
        } catch (e) {
            throw e
        }
    }
    async getCompanyById(companyId: string): Promise<CompanyIdDTO> {
        try {
            const response = await http.sendGet<CompanyIdDTO>(`client/companies/${companyId}`, undefined, ApiRootType.one)
            return response.data
        } catch (e) {
            throw e
        }
    }
    async getCompaniesChildren(): Promise<CompanyChildDTO[]> {
        try {
            const response = await http.sendGet<CompanyChildDTO[]>('client/companies/children', undefined, ApiRootType.one)
            return response.data
        } catch (e) {
            throw e
        }
    }
    async getUser(): Promise<UserDTO[]> {
        try {
            const response = await http.sendGet<UserDTO[]>('client/users', undefined, ApiRootType.one)
            return response.data
        } catch (e) {
            throw e
        }
    }
    async postUser(data: createUserRequestDTO): Promise<UserResponseDTO> {
        try {
            const response = await http.post<UserResponseDTO>('client/users', data, {}, ApiRootType.one)
            return response.data
        } catch (e) {
            throw e
        }
    }
    async putUser(userId: string, data: createUserRequestDTO): Promise<UserResponseDTO> {
        try {
            const response = await http.put<UserResponseDTO>(`client/users/${userId}`, data, 6000, undefined, ApiRootType.one)
            return response.data
        } catch (e) {
            throw e
        }
    }
    async deleteUser(userId: string): Promise<void> {
        try {
            await http.delete(`client/users/${userId}`, 6000, ApiRootType.one)
        } catch (e) {
            throw e
        }
    }
    async getUserExport(format: 'CSV' | 'XLSX'): Promise<void> {
        try {
            await http.get<Blob>('client/users/export', {params: { format },  downloadFilename: `users.${format}` }, ApiRootType.one)
        } catch (e) {
            throw e
        }
    }
    async getSite(): Promise<SiteResponseDTO[]> {
        try {
            const response = await http.sendGet<SiteResponseDTO[]>('client/sites', undefined, ApiRootType.one)
            return response.data
        } catch (e) {
            throw e
        }
    }
    async getSiteExport(format: 'CSV' | 'XLSX', societeId?: string): Promise<void> {
        try {
            await http.get<Blob>(
                'client/sites/export',
                { params: societeId ? { societeId, format } : { format }, downloadFilename: `sites.${format}` },
                ApiRootType.one
            )
        } catch (e) {
            throw e
        }
    }
    async getSiteExportById(siteId: string, format: 'CSV' | 'XLSX'): Promise<void> {
        try {
            await http.get<Blob>(`client/sites/${siteId}/zones/export`, { params: { format }, downloadFilename: `site.${format}` }, ApiRootType.one)
        } catch (e) {
            throw e
        }
    }
    async getCatalog(): Promise<CatalogResponseDTO[]> {
        try {
            const response = await http.sendGet<CatalogResponseDTO[]>('client/catalogs', undefined, ApiRootType.one)
            return response.data
        } catch (e) {
            throw e
        }
    }
    async putCatalog(catalogId: string, data: ChannelSettingsDTO): Promise<CatalogResponseDTO> {
        try {
            const response = await http.put<CatalogResponseDTO>(
                `client/catalogs/${catalogId}/channels`,
                data,
                6000,
                undefined,
                ApiRootType.one
            )
            return response.data
        } catch (e) {
            throw e
        }
    }

    async putCatalogDisplayName(catalogId: string, displayName: string): Promise<CatalogDisplayNameResponseDTO> {
        try {
            const response = await http.put<CatalogDisplayNameResponseDTO>(
                `client/catalogs/${catalogId}/display-name`,
                { displayName },
                6000,
                undefined,
                ApiRootType.one
            )
            return response.data
        } catch (e) {
            throw e
        }
    }

    async postCatalogLogo(catalogId: string, logo: string): Promise<CatalogLogoResponseDTO> {
        try {
            const response = await http.post<CatalogLogoResponseDTO>(`client/catalogs/${catalogId}/logo`, { logo }, {}, ApiRootType.one)
            return response.data
        } catch (e) {
            throw e
        }
    }
    async deleteCatalogLogo(catalogId: string): Promise<CatalogLogoResponseDTO> {
        try {
            const response = await http.delete(`client/catalogs/${catalogId}/logo`, 6000, ApiRootType.one)
            return response.data as CatalogLogoResponseDTO
        } catch (e) {
            throw e
        }
    }

    async getCatalogExportId(catalogId: string, format: 'CSV' | 'XLSX'): Promise<void> {
        try {
            await http.get<Blob>(
                `client/catalogs/${catalogId}/export`,
                { params: { format }, downloadFilename: `catalog.${format}` },
                ApiRootType.one
            )
        } catch (e) {
            throw e
        }
    }
    async getCatalogExport(format: 'CSV' | 'XLSX'): Promise<void> {
        try {
            await http.get<Blob>('client/catalogs/export', { params: { format }, downloadFilename: `catalogs.${format}` }, ApiRootType.one)
        } catch (e) {
            throw e
        }
    }
    async getRole(): Promise<RoleDTO[]> {
        try {
            const response = await http.sendGet<RoleDTO[]>('roles', undefined, ApiRootType.one)
            return response.data
        } catch (e) {
            throw e
        }
    }
    async resetPwd(email: string): Promise<ResetPwdDTO> {
        try {
            const response = await http.post<ResetPwdDTO>('auth/recover', { email }, {}, ApiRootType.one)
            return response.data
        } catch (e) {
            throw e
        }
    }
}
